module.exports = __webpack_public_path__ + "static/media/java.0ee7950b.PNG";